/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { makeStyles, TableBody, Typography } from '@material-ui/core';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { SimCardCollectionInterface } from '../../../interfaces/collections/SimCardCollectionInterface';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { history } from '../../../core/history';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import ViewButton from '../../../components/Buttons/ViewButton';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import SettingsButton from '../../../components/Buttons/SettingsButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';

type ImsiHistoryType = {
    classes: any;
    imsi: PlatformIccidPoolNumber;
};

const ImsiHistory: FunctionComponent<ImsiHistoryType> = ({ classes, imsi }): React.ReactElement => {
    const [simCards, setSimCards] = useState<SimCardCollectionInterface | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_cards')),
            'msisdn_history_storage_view_get',
            [{ name: 'imsi', value: imsi.imsi }],
            [
                { name: 'deleted', value: 'asc' },
                { name: 'id', value: 'desc' },
            ],
            (data: SimCardCollectionInterface) => {
                setSimCards(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch, imsi]);

    const goToMsisdnStorage = (item: { uri: string }): void => {
        history.push(FormGeneralHelper.getRouteUrl('/msisdn-view' + item.uri));
    };

    const goToProduct = (item: { uri: string }): void => {
        history.push(FormGeneralHelper.getRouteUrl('/sim-card-edit' + item.uri));
    };

    const tableRowRoot = { root: classes.tableRowRoot };
    const tableCellRoot = { root: classes.tableCellRootBordered };

    return (
        <Card>
            <CardHeader trans="pools:pool.parring_history" />
            <CardBody>
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell textAlign="left" title="general:common.commands" />
                            </TableCell>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:pool.msisdn"
                                    fieldName="imsi"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:pool.change_date"
                                    fieldName="parentProductDate"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {simCards &&
                            simCards['hydra:member'] &&
                            simCards['hydra:member'].map((simCard: SimCardInterface) => {
                                return (
                                    <TableRow key={'sim_card_asd_' + simCard.id} classes={tableRowRoot}>
                                        <TableCell classes={tableCellRoot} padding="none" align="left" style={{ paddingLeft: 0 }}>
                                            {simCard.platformMsisdnPoolNumber && (
                                                <ViewButton
                                                    tooltipTitle="pools:msisdn.msisdn_view"
                                                    callback={goToMsisdnStorage}
                                                    callbackParam={{ uri: simCard.platformMsisdnPoolNumber }}
                                                />
                                            )}
                                            <SettingsButton
                                                callback={goToProduct}
                                                callbackParam={{ uri: simCard['@id'] }}
                                                tooltipTitle="pools:msisdn.produkt_view"
                                            />
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {!simCard.deleted && simCard.msisdn}
                                            {simCard.deleted && simCard.lastMsisdn}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {!simCard.active && simCard.deleted && simCard.deletedDate && (
                                                <I18n
                                                    trans="pools:msisdn.activation_canceled"
                                                    valueObject={{ date: DateHelperTs.format(simCard.deletedDate) }}
                                                />
                                            )}
                                            {simCard.parentProductDate && DateHelperTs.format(simCard.parentProductDate)}
                                            {simCard.active &&
                                                !simCard.parentProductDate &&
                                                simCard.deletedDate &&
                                                DateHelperTs.format(simCard.deletedDate)}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </PaperedTable>
            </CardBody>
        </Card>
    );
};

export default withStyles(oplAppStyle)(ImsiHistory);
